import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotFound } from '@freelancer/404';

@Component({
  standalone: false,
  selector: 'app-not-found',

  template: `
    <app-nav></app-nav>
    <div class="MainContainer">
      <fl-card>
        <h1
          class="text-mid"
          [flMarginBottom]="'large'"
        >
          Error: Page not found
        </h1>
      </fl-card>
    </div>
  `,
  styleUrls: [
    '../static-pages/static-pages.component.scss',
    './not-found.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  constructor(private notFound: NotFound) {}

  ngOnInit(): void {
    this.notFound._onRender();
  }
}
